import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-page-not-found',
  imports: [CommonModule, RouterModule, Button],
  template: `
    <div class="flex h-screen">
      <!-- Left side: error text and abstract scribble -->
      <div class="w-1/2 bg-cyan-950 text-lime-400 flex items-center justify-center relative overflow-hidden">
        <h1 class="text-[10rem] font-bold tracking-wide leading-none z-10">ERROR<br />404.</h1>
        <div class="absolute inset-0 flex items-center justify-center z-0">
          <svg class="w-full h-full opacity-30" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10,10 C100,300 200,0 300,200 S400,400 500,50"
              fill="none"
              stroke="#88c2d9"
              stroke-linecap="round"
              stroke-width="10" />
            <!-- Add more paths for complexity -->
          </svg>
        </div>
      </div>

      <!-- Right side: message -->
      <div class="w-1/2 bg-white flex items-center justify-center">
        <div class="flex flex-col text-center space-y-4 px-4">
          <div class="text-slate-950 text-base font-semibold flex items-center justify-center space-x-2">
            <i class="pi pi-info-circle text-2xl text-slate-950"></i>
            <span>Page Not Found</span>
          </div>
          <p class="text-slate-950 text-sm">
            <strong>The link you followed may be broken, or the page may no longer exist.</strong>
          </p>
          <p class="text-slate-950 text-sm mb-4">
            If you believe this is an error or you need access, please contact your administrator.
          </p>
          <p-button label="Back to Home" routerLink="/" />
        </div>
      </div>
    </div>
  `,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundUiComponent {}
